import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/** "Tour this page" for My Sites (/sites). Anchors live in MySitesPage.tsx. */
export function getMySitesTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'My Sites',
        description:
          'Every website on your account lives here. Create a new site, choose which one is your ' +
          'main site, and jump into editing any of them.',
      },
    },
    {
      element: at('sites-create'),
      popover: {
        title: 'Create a new site',
        description:
          'Give your new site a name. The web address part (the slug) is optional — leave it blank ' +
          'and we’ll fill it in for you. New sites start as a draft and don’t touch your other sites.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('sites-create-button'),
      popover: {
        title: 'Create Site',
        description:
          'Click here when you’re ready. The setup wizard opens for your new site right away so ' +
          'you can start building it.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('sites-list'),
      popover: {
        title: 'Your sites',
        description:
          'All your sites are listed here, with your primary site first. Each one shows its name, ' +
          'web address, and whether it’s live or still a draft.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('sites-actions'),
      popover: {
        title: 'Work on a site',
        description:
          '“Edit in Studio” opens the site in the editor, and “Set up” runs the setup wizard. On ' +
          'extra sites you can also publish or unpublish, use “Make Primary” to make it the site at ' +
          'your main web address, or “Remove” it. Your primary site can’t be removed.',
        side: 'left',
        align: 'start',
      },
    },
  ];
}
